import { DashboardCard, Data, Http, Parameters } from '../../../models/index';
import { GetResource } from '../GetResource';
import { PostResource } from '../PostResource';
import { GetDataLevel } from './GetDataLevel';

export namespace GetData {
    export interface Params {
        card: DashboardCard;
        cardViewType: string;
        parameters?: Parameters<DashboardCard.Params>;
        entityId: number;
        productionMode?: string;
        pricingStructure?: string;
    }
}

const DATE_REGEX = /^\d{4}-\d{2}-\d{2}/;

export class GetData {
    private getResource: GetResource<DashboardCard.Rel, Data>;
    private postResource: PostResource<DashboardCard.Rel, Parameters<DashboardCard.Params>, Data>;

    private getDataLevel = new GetDataLevel();

    constructor(http: Http) {
        //super();
        this.getResource = new GetResource<DashboardCard.Rel, Data>(http);
        this.postResource = new PostResource<
            DashboardCard.Rel,
            Parameters<DashboardCard.Params>,
            Data
        >(http);
    }

    //async execute(params: GetData.Params): Promise<Data>;

    /* async execute(params: GetData.Params): Promise<Data> {

    // If parameters are provided, we should get fresh data but not update what
    // is cached. Saving a card will update its cached data.
    const doNotUpdateCache = !!params.parameters;
    if (doNotUpdateCache) {
      params.clearCache = true;
    }

    const previousData = this.getCachedValue(params);
    const data = await super.execute(params);
    if (doNotUpdateCache) {
      this.setCachedValue(previousData, params);
    }

    return data;
  } */

    protected getId(params: GetData.Params): number {
        return params.card.id!;
    }

    execute({
        card,
        parameters,
        cardViewType,
        entityId,
        productionMode,
        pricingStructure
    }: GetData.Params): Promise<Data> {
        let request: Promise<Data | undefined>;
        let searchParams = {};
        if (this.isPortfolioCard(card)) {
            searchParams = { entityId, productionMode, pricingStructure };
        } else {
            searchParams = { entityId };
        }
        Object.keys(searchParams).forEach(
            (key) => searchParams[key] == null && delete searchParams[key]
        );

        if (!parameters) {
            request = this.getResource.execute({
                parent: card,
                rel: 'data',
                queryParams: {
                    cardViewType
                },
                search: searchParams,
                useCache: false
            });
        } else {
            request = this.postResource.execute({
                parent: card,
                rel: 'data',
                body: parameters,
                queryParams: {
                    cardViewType
                },
                search: searchParams
            });
        }

        return request.then((data?: Data) => {
            data = data || {
                dataStatus: 'INITIAL',
                hidden: 'false',
                values: [] as Data['values']
            };

            if (!card.card.parameters.fixedCompare) {
                // TODO: Remove this transformation once data cleanup is complete
                if (data.values.length && !Array.isArray(data.values[0])) {
                    data.values = <any>[data.values];
                }

                // TODO: tests for date column massage
                let dateColIndex = -1;
                data.values = data.values.map((points) => {
                    points = points.map((point: any, i) => {
                        if (point && typeof point === 'object') {
                            if (
                                typeof point.data === 'undefined' ||
                                point.data === 'N\\A' ||
                                point.data === 'N/A'
                            ) {
                                return null;
                            } else {
                                // TODO: handle this properly on backend
                                /* if (i === 0 && typeof point.data === 'string') {
                                    // needed because some strings moment converts to real date (e.g. Strefa 5 which is the name for Org Zone in Farmbook)
                                    const validDateFormats = ['YYYY-MM-DD'];
                                    const isStringValidDate = moment(
                                        point.data,
                                        validDateFormats,
                                        true
                                    ).isValid();
                                    if (isStringValidDate) {
                                        const m = moment(forceUtc(point.data)).utc().toString();
                                        if (m !== 'Invalid date') return m;
                                    }
                                } */
                                return point.data;
                            }
                        } else if (
                            typeof point === 'undefined' ||
                            point === 'N\\A' ||
                            point === 'N/A'
                        ) {
                            return null;
                        } else {
                            return point;
                        }
                    });

                    //Removed because it was causing issue on cards with Rank and Date, where Rank should stay on first place in table
                    //Backend should send X-axis value on first index in all cases
                    // if (dateColIndex === -1) {
                    //   dateColIndex = points.findIndex(point =>
                    //     DATE_REGEX.test(<string>point)
                    //   );
                    // }

                    // if (dateColIndex > 0) {
                    //   // Ensure date value is first column
                    //   points.unshift(...points.splice(dateColIndex, 1));
                    // }

                    return points;
                });
            }

            if (!data.values.length) {
                // No data should contain an empty row with null values for each series
                const cardAttr: any = card.attributes;
                const cardType = cardAttr.defaults.types.desktop;

                if (cardType == 'table') {
                    data.values;
                } else {
                    if (data.headers) {
                        data.values.push(Array(data.headers.length).fill(null));
                    }
                }
            }

            return data;
        });
    }

    private isPortfolioCard(value: any): value is DashboardCard {
        return value && value.card && value.card.portfolioFeatureSetId;
    }
}
